import { render, staticRenderFns } from "./product-card-new.vue?vue&type=template&id=aba59118&scoped=true&"
import script from "./product-card-new.vue?vue&type=script&lang=js&"
export * from "./product-card-new.vue?vue&type=script&lang=js&"
import style0 from "./product-card-new.vue?vue&type=style&index=0&id=aba59118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba59118",
  null
  
)

export default component.exports